import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  VStack,
  HStack,
  Text,
  Link,
  Icon,
  Divider,
  Button,
  Image,
  SimpleGrid,
  Stack,
  IconButton
} from '@chakra-ui/react';
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt
} from 'react-icons/fa';

const Footer = () => {
  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';

  const socialLinks = [
    { icon: FaFacebookF, url: '#', color: '#1877F2', label: 'فيسبوك' },
    { icon: FaInstagram, url: '#', color: '#E4405F', label: 'إنستغرام' },
    { icon: FaYoutube, url: '#', color: '#FF0000', label: 'يوتيوب' },
    { icon: FaWhatsapp, url: 'https://wa.me/21622779137', color: '#25D366', label: 'واتساب' }
  ];

  return (
    <Box
      bg={secondaryColor}
      color="white"
      pt={16}
      pb={8}
      dir="rtl"
      fontFamily="Tajawal, sans-serif"
      position="relative"
      overflow="hidden"
    >
      {/* Decorative background element */}
      <Box
        position="absolute"
        top="-10%"
        right="-5%"
        width="300px"
        height="300px"
        bg={primaryColor}
        opacity="0.05"
        borderRadius="full"
        filter="blur(80px)"
      />

      <Container maxW="1400px">
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={12} mb={12}>
          {/* Brand Column */}
          <VStack align="flex-start" spacing={6}>
            <Image
              src="https://i.imgur.com/EFLnpkN.png"
              alt="منصة كوبرا التعليمية"
              h="65px"
              objectFit="contain"
            />
            <Text fontSize="md" lineHeight="1.8" color="whiteAlpha.800">
              الرائدة في التعليم الإلكتروني في تونس. نوفر للتلاميذ أفضل الموارد التعليمية والدروس المباشرة لضمان التميز والنجاح الدراسي.
            </Text>
            <HStack spacing={4}>
              {socialLinks.map((social, index) => (
                <IconButton
                  key={index}
                  as="a"
                  href={social.url}
                  target="_blank"
                  aria-label={social.label}
                  icon={<Icon as={social.icon} />}
                  variant="ghost"
                  color="white"
                  fontSize="xl"
                  _hover={{
                    color: primaryColor,
                    bg: 'whiteAlpha.100',
                    transform: 'translateY(-3px)'
                  }}
                  transition="all 0.3s"
                />
              ))}
            </HStack>
          </VStack>

          {/* Quick Links Column */}
          <VStack align="flex-start" spacing={6}>
            <Text
              fontSize="xl"
              fontWeight="900"
              color={primaryColor}
              fontFamily="Cairo, sans-serif"
            >
              روابط سريعة
            </Text>
            <VStack align="flex-start" spacing={3}>
              <Link as={RouterLink} to="/" _hover={{ color: primaryColor, transform: 'translateX(-5px)' }} transition="all 0.2s">الرئيسية</Link>
              <Link as={RouterLink} to="/discover" _hover={{ color: primaryColor, transform: 'translateX(-5px)' }} transition="all 0.2s">اكتشف المستويات</Link>
              <Link as={RouterLink} to="/packs" _hover={{ color: primaryColor, transform: 'translateX(-5px)' }} transition="all 0.2s">عروضنا التعليمية</Link>
              <Link as={RouterLink} to="/about" _hover={{ color: primaryColor, transform: 'translateX(-5px)' }} transition="all 0.2s">حول المنصة</Link>
              <Link as={RouterLink} to="/contact" _hover={{ color: primaryColor, transform: 'translateX(-5px)' }} transition="all 0.2s">اتصل بنا</Link>
            </VStack>
          </VStack>

          {/* Contact Details Column */}
          <VStack align="flex-start" spacing={6}>
            <Text
              fontSize="xl"
              fontWeight="900"
              color={primaryColor}
              fontFamily="Cairo, sans-serif"
            >
              تواصل معنا
            </Text>
            <VStack align="flex-start" spacing={4}>
              <HStack spacing={4} align="center">
                <Box p={2} bg="whiteAlpha.100" borderRadius="lg">
                  <Icon as={FaPhone} boxSize={4} color={primaryColor} />
                </Box>
                <Link href="tel:+21622779137" _hover={{ color: primaryColor }}>22779137</Link>
              </HStack>
              <HStack spacing={4} align="center">
                <Box p={2} bg="whiteAlpha.100" borderRadius="lg">
                  <Icon as={FaWhatsapp} boxSize={4} color={primaryColor} />
                </Box>
                <Link href="https://wa.me/21622779137" _hover={{ color: primaryColor }}>تواصل عبر واتساب</Link>
              </HStack>
              <HStack spacing={4} align="center">
                <Box p={2} bg="whiteAlpha.100" borderRadius="lg">
                  <Icon as={FaEnvelope} boxSize={4} color={primaryColor} />
                </Box>
                <Link href="mailto:loussifiacademy@gmail.com" _hover={{ color: primaryColor }}>loussifiacademy@gmail.com</Link>
              </HStack>
              <HStack spacing={4} align="center">
                <Box p={2} bg="whiteAlpha.100" borderRadius="lg">
                  <Icon as={FaMapMarkerAlt} boxSize={4} color={primaryColor} />
                </Box>
                <Text>تونس، الجمهورية التونسية</Text>
              </HStack>
            </VStack>
          </VStack>

          {/* Newsletter/CTA Column */}
          <VStack align="flex-start" spacing={6}>
            <Text
              fontSize="xl"
              fontWeight="900"
              color={primaryColor}
              fontFamily="Cairo, sans-serif"
            >
              جاهز للتميز الدراسي؟
            </Text>
            <Text fontSize="md" color="whiteAlpha.800">
              سجل طفلك الآن في أحد عروضنا واحصل على وصول فوري لأفضل الموارد التعليمية.
            </Text>
            <Button
              as={RouterLink}
              to="/packs"
              bg={primaryColor}
              color={secondaryColor}
              size="lg"
              w="100%"
              _hover={{
                bg: 'white',
                transform: 'scale(1.02)'
              }}
              _active={{ transform: 'scale(0.98)' }}
              fontFamily="Cairo, sans-serif"
              fontWeight="900"
              borderRadius="xl"
              boxShadow="lg"
            >
              استكشف العروض
            </Button>
          </VStack>
        </SimpleGrid>

        <Divider borderColor="whiteAlpha.200" mb={8} />

        {/* Bottom Bar */}
        <Stack
          direction={{ base: 'column', md: 'row' }}
          justify="space-between"
          align="center"
          spacing={4}
        >
          <Text fontSize="sm" color="whiteAlpha.600">
            © 2024 منصة كوبرا التعليمية. جميع الحقوق محفوظة. تم التطوير بكل حب للتلاميذ التونسيين.
          </Text>
          <HStack spacing={6}>
            <Link href="#" fontSize="xs" color="whiteAlpha.500" _hover={{ color: primaryColor }}>سياسة الخصوصية</Link>
            <Link href="#" fontSize="xs" color="whiteAlpha.500" _hover={{ color: primaryColor }}>شروط الاستخدام</Link>
          </HStack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;